
import React, { memo } from 'react';
import { CardFooter } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

interface PollWidgetNavigationProps {
  currentIndex: number;
  totalPolls: number;
  onPrevious: () => void;
  onNext: () => void;
}

// Use React.memo to prevent unnecessary re-renders
const PollWidgetNavigation = memo(({
  currentIndex,
  totalPolls,
  onPrevious,
  onNext
}: PollWidgetNavigationProps) => {
  if (totalPolls <= 1) return null;
  
  return (
    <CardFooter className="flex justify-between">
      <Button 
        variant="outline" 
        onClick={onPrevious} 
        disabled={currentIndex === 0}
      >
        Previous
      </Button>
      
      <span className="text-sm text-muted-foreground">
        {currentIndex + 1} / {totalPolls}
      </span>
      
      <Button 
        variant="outline" 
        onClick={onNext} 
        disabled={currentIndex === totalPolls - 1}
      >
        Next
      </Button>
    </CardFooter>
  );
});

PollWidgetNavigation.displayName = 'PollWidgetNavigation';

export default PollWidgetNavigation;
